// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","resultHistory":"_3qsBv","year":"_1woGV","docs":"_3il95","event":"SG5UG","docList":"QG2O2","document":"_3Mg7k","title":"ZGx5B"};